import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const Disclaimer = () => {
  const [disclaimerContent, setDisclaimerContent] = useState("");

  useEffect(() => {
    fetch("/disclaimer.txt")
      .then((res) => res.text())
      .then((text) => setDisclaimerContent(text))
      .catch((err) => console.error("Failed to load Disclaimer", err));
  }, []);

  return (
    <>
      <Helmet>
        <title>Disclaimer - limkc.com</title>
        <meta name="description" content="Read the Disclaimer of limkc.com to understand the limitations of liability, accuracy of information, and responsible usage of this website." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      {/* 
        Following top-down UI architecture:
        - w-full h-full ensures it fills available space
        - overflow-auto handles content overflow
        - px-4 adds consistent horizontal padding inside the component
      */}
      <div className="w-full h-full overflow-auto">
      <div className="px-4 py-6 transition-all duration-300"
   style={{
    paddingTop: 'calc(var(--navbar-height) + 1.5rem)', // Adds navbar height + existing py-6 (1.5rem)
  }}>
          <h2 className="text-xl font-bold mb-4 text-center text-gray-800">Disclaimer</h2>
          <p className="text-sm text-gray-500 text-center mb-4">Last Updated: 2025-02-08</p>
          <div className="prose text-gray-600">
            <ReactMarkdown>{disclaimerContent}</ReactMarkdown>
          </div>
          <div className="text-center mt-6">
            <Link to="/terms" className="text-blue-500 hover:underline">View Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;

